import { Controller } from "@hotwired/stimulus";

// Inbox: selection opens /users/:id/messages via Turbo.
export default class extends Controller {
  visit(event) {
    const select = event.currentTarget;
    const url = select.value;
    if (!url) return;
    if (window.Turbo?.visit) {
      window.Turbo.visit(url);
    } else {
      window.location.assign(url);
    }
    select.selectedIndex = 0;
  }
}
